<template>
  <div class="carousel-navigation">
    <button
      v-if="autoplay"
      :aria-label="play ? labels.navigation.pauseAlt : labels.navigation.playAlt"
      :class="['carousel-navigation-button', { 'carousel-navigation-play' : !play }, { 'carousel-navigation-pause' : play }]"
      @click.prevent="$emit('toggleAutoPlay'), play = !play"
    >
      <div class="icon" />
    </button>
    <button
      v-if="showNavigation && canGoBack"
      ref="prevButton"
      :aria-label="labels.navigation ? labels.navigation.leftArrowAlt : 'Left Arrow'"
      class="carousel-navigation-button carousel-navigation-prev"
      @click.prevent="$emit('changeSlide', 'backward'), parentContainer.pushTaggingToDatalayer('backwards')"
    >
      <slot name="customPrevIcon" />
      <svg
        v-if="!hasCustomPrevIconSlot"
        class="carousel-icon--reverse"
        enable-background="new 0 0 29.8 48"
        version="1.1"
        viewBox="0 0 29.8 48"
        xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5.8,0L0.2,5.7L18.5,24L0.2,42.3L5.8,48l24-24L5.8,0z" />
      </svg>
    </button>
    <button
      v-if="showNavigation && canGoForward"
      ref="nextButton"
      :aria-label="labels.navigation ? labels.navigation.rightArrowAlt : 'Right Arrow'"
      class="carousel-navigation-button carousel-navigation-next"
      @click.prevent="$emit('changeSlide', 'forward'), parentContainer.pushTaggingToDatalayer('forward')"
    >
      <slot name="customNextIcon" />
      <svg
        v-if="!hasCustomNextIconSlot"
        enable-background="new 0 0 29.8 48"
        version="1.1"
        viewBox="0 0 29.8 48"
        xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5.8,0L0.2,5.7L18.5,24L0.2,42.3L5.8,48l24-24L5.8,0z" />
      </svg>
    </button>
  </div>
</template>

<script>
  import { tag } from '@Foundation/analyticsHandler';

  export default {
    name: 'Navigation',
    directives: {
      tag
    },
    props: {
      labels: { type: Object, required: true },
      autoplay: { type: Boolean, required: false, default: false },
      showNavigation: { type: Boolean, required: false, default: false },
      canGoForward: { type: Boolean, required: false, default: true },
      canGoBack: { type: Boolean, required: false, default: true }
    },
    data() {
      return {
        play: true,
        parentContainer: this.$parent
      };
    },
    computed: {
      hasCustomNextIconSlot() {
        return !!this.$slots.customNextIcon;
      },
      hasCustomPrevIconSlot() {
        return !!this.$slots.customPrevIcon;
      }
    }
  };
</script>
